import { render, staticRenderFns } from "./StudentPreRegistrationUpdate.vue?vue&type=template&id=18078de1&scoped=true"
import script from "./StudentPreRegistrationUpdate.vue?vue&type=script&lang=js"
export * from "./StudentPreRegistrationUpdate.vue?vue&type=script&lang=js"
import style0 from "./StudentPreRegistrationUpdate.vue?vue&type=style&index=0&id=18078de1&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18078de1",
  null
  
)

export default component.exports